
const API_SCOPE = `api://${process.env.VUE_APP_API_CLIENT_ID}/user_impersonation`;

const state = () => ({
   // msal_user - the authenticated user - the user selected in the popup 
   instance_name: 'default',
   create_timestamp: null,
   msal_user: null, 
   msal_user_fullname: null,
   // app_user - the authorized user that includes the application roles
   app_user : null,

   // msal_app - the PublicClientApplication object used for authentication
   msal_app: null,

   // id_token - the idToken returned from UI authentication
   id_token: null,

   // access_token - the access token returned from UI authentication
   access_token: null,

   // api_id_token - the idToken retrieved by calling the API - pass the UI token and receive the api token
   api_id_token: null,
   api_id_token_exp: null,
   initial_load_stat : 0,

   auth: {},

   first_login_in_prog: true,
   login_in_progress: false,
   interaction_required: false,
   auth_status: 0,
   auth_fail: false,
   authenticated: false,
   authorized: false,

   error_general : {},
   error_auth: {},
   errors: []

});

const authStatusList = {
  
    NONE : 0,
    STARTED: 1,
    AUTHENTICATED: 2,
    AUTHORIZED: 3,
    ERROR: 4,
    LOGGEDOUT: 5
   
};
const mutations = {
    // Initial Set All list
    SET_ERR: (state, msg) => {
        state.errorMsg = msg;
    },
    SET_ERR_FLAG: (state, value) => {
        state.auth_fail = value;
    },
    SET_MSAL: (state,value) => {
        //Vue.set(this.state,'Program',value);
        //Vue.set(this.state,"msal_app",value)
        state.msal_app = value;
        state.auth_status = authStatusList.STARTED;
    },
   
    SET_MSAL_USER: (state, acct) => {
        state.msal_user = acct;
        if (acct){
            state.msal_user_fullname = acct.name;
            state.authenticated = true;            
        } else {
            state.msalUserFullName = null;
            state.authenticated = false;
        }
        
    },

    SET_USER: (state, object) => {
        state.app_user = object;
    },

    SET_APP_USER: (state, object) => {
        state.app_user = object;
        state.authUser = object;
    },
    SET_IDTOKEN: (state, value) => {
        state.id_token = value;
        if ( state.msal_user){
            state.msal_user.idToken = value
        }
    },
    SET_API_IDTOKEN: (state, value) => {
        state.api_id_token = value;
    },
    SET_API_IDTOKEN_EXP: (state,value) => {
        state.api_id_token_exp = value;
    },
    SET_TOKEN: (state,value) => {
        state.access_token = value
    },
    SET_ACCESSTOKEN: (state, value) => {
        state.accessToken = value;
       // Vue.set(state,'auth_user.accessToken',value);
        //state.auth_user.accessToken = value
    },
    SET_INSTANCE_NAME: (state, value) => {
        state.instance_name = value;
       // Vue.set(state,'auth_user.accessToken',value);
        //state.auth_user.accessToken = value
    },
    SET_CREATE_TS: (state,value) =>{
        state.create_timestamp = value;
    },
    // Set state.acan be 0,1,2,3
    // 0 = no authentication or authorization done
    // 1 = auth started but not completed
    // 2 = user has been authenticated (have an access token for UI app)
    // 3 = user has been authorized for the eum app and roles retrieved
    // 4 = error encountered during auth
    // 5 = logged out

    SET_AUTH_STATUS: (state,value) => {
        state.auth_status = value;
        //Vue.set(state,'userIsAuthenticated',value);
    },

    SET_AUTH: (state,value) => {
        state.auth = value;
    },
    SET_AUTHENTICATED: (state,value) =>{
        state.authenticated = value;
    },
    SET_AUTHORIZED: (state,value) =>{
        state.authorized = value;
    },
    SET_FIRST_LOGIN: (state,value) => {
        state.first_login_in_prog = value;
    },
    SET_LOGIN_IN_PROG: (state,value) => {
        state.login_in_progress = value;
    },
    SET_INTERACTION_REQUIRED: (state,value) => {
        state.interaction_required = value;
    },
    SET_INITIAL_LOAD_STAT: (state,value) => {
        state.initial_load_stat = value;
    }
}
const getters = {
    authIdToken: (state,getters) => {
        if (getters.auth_idToken == undefined) {
            return 'blank';
        }else {
            return state.auth_idToken;
        }
       

    },

    GetMsalApp: (state) => state.msal_app,
    msalApp: (state) => state.msal_app,
    msal_app: (state) => state.msal_app,
    user: (state) => state.msal_user,
    storedAppUser: (state) => state.app_user,
    storedMsalUser: (state) => state.msal_user,
    msalUserFullName: (state) => state.msal_user_fullname,
    authUser: (state) => state.app_user,

    authenticated: (state) => state.authenticated,
    authorized: (state) => state.authorized, 

    id_token: (state) => state.id_token,
    ui_idtoken: (state) => state.id_token,
    api_idtoken: (state) => state.api_id_token,
    api_idtoken_exp: (state) => state.api_id_token_exp,
    accesstoken: (state) => state.access_token,
    access_token: (state) => state.access_token,
    authStatus: (state) => state.auth_status,
    auth: (state) => state.auth,
    firstLoginInProg: (state) => state.login_in_progress,
    loginInProgress: (state) => state.login_in_progress,
    interactionRequired: (state) => state.interaction_required,
    getInstanceName: (state) => state.instance_name,
    getCreateTS:(state) => state.create_timestamp,
    isInitialLoadDone: (state) => {
        return state.initial_load_stat == 2
    },
    isInitialLoadStarted: (state) => {
        return state.initial_load_stat == 1
    },
    isInitialLoadNotStarted: (state) => {
        return state.initial_load_stat == 0
    },
    userIsAuthenticated: (state,getters) =>
    {
        if (getters.authStatus === 2 ||
        getters.authStatus === 3 )
        {
            return true;
        } else {
            return false;
        }

    },
    userIsAuthorized: (state,getters) =>
    {
        let authed = false;
        let auser = getters.storedAppUser;
       try {
        if (auser!= null && auser.idToken != "" && 
                (auser.UserRoles && auser.UserRoles.length > 0)
                ){


                   return true;
                }
                else {
                    return false;
                }
        // if (getters.authStatus === 3)
        // {
        //     return true;
        // } else {
        //     return false;
        // }
            }catch(err) {
                console.log(`error in authModule.userIsAuthorized: `,err)
            return false;
        }

    },
    loginShouldBeVisible: (state,getters) =>
       {
            let shouldbe = 
              (  state.auth_status == 0 ||
                state.auth_status == 1 || 
               // !state.loginInProgress || 
               !state.authorized
              ) || state.initial_load_stat != 2
                 ;
            console.log(`  --- loginShouldBeVisible: ${shouldbe} ---`);
           return shouldbe;
      
        },
    apiTokenIsValid: (state,getters) =>
    {

        let exp = getters.api_idtoken_exp;
        let expireDate = new Date(exp)
        console.log(`expireDate `,expireDate);
        let isvalid = 
        (expireDate > new Date())

        return isvalid;
    }

    
}

const actions = {
    LogoutUser(state) {
        console.log("[authModule] LogoutUser()")
        state.commit("SET_USER",null);
        state.commit("SET_APP_USER",null);
        state.commit("SET_MSAL_USER",null);
        
        state.commit("SET_LOGIN_IN_PROG",false);
        state.commit("SET_AUTH_STATUS",5);
        state.commit("SET_AUTHENTICATED",false);
        state.commit("SET_AUTHORIZED",false);

        state.commit("SET_IDTOKEN",null);
        state.commit("SET_API_IDTOKEN",null);
        
        state.commit("SET_ACCESSTOKEN",null);
        state.commit("SET_FIRST_LOGIN", true);
        state.commit("SET_INITIAL_LOAD_STAT",0);

        return state.msal_user;

    },
    RandomAction(state, val){
            console.log("RandomAction")
            console.log(val);
    },
    SetIdToken(state, updatedVal){
        console.log(`[authModule] SetIdToken executing - ${updatedVal}`)
        state.commit("SET_IDTOKEN",updatedVal)
        return state.id_token 
    },
    SetApiIdToken(state, updatedVal){
        console.log(`[authModule] SetApiIdToken executing - ${updatedVal}`)
        state.commit("SET_API_IDTOKEN",updatedVal)
        return state.api_id_token; 
    },
    SetAccessToken(state, updatedVal){
        console.log(`[authModule] SetIdToken executing - ${updatedVal}`)
        state.commit("SET_ACCESSTOKEN",updatedVal)
        return state.access_token;
    },
 
    SetTokens(state,tokenResp){
        if (tokenResp.scopes.includes(API_SCOPE))
        {
            state.commit("SET_API_IDTOKEN",tokenResp.idToken);
            state.commit("SET_API_IDTOKEN_EXP", tokenResp.expiresOn)
        } else {
            state.commit("SET_IDTOKEN",tokenResp.idToken);
            
        }
        
       // state.commit("SET_API_IDTOKEN",payload.idToken);
        state.commit("SET_ACCESSTOKEN",tokenResp.accessToken);
        return true;
    },

    SetAuthenticated({commit},payload){

        commit("SET_AUTHENTICATED",payload);
       
       
    },
    SetAuthorized({commit},payload){

        commit("SET_AUTHORIZED",payload);
        if (payload == true){
            commit("SET_LOGIN_IN_PROG",false);
        }
       
    },
    ClearTokens(state){

        state.commit("SET_IDTOKEN",null);
        state.commit("SET_ACCESSTOKEN",null);
    },
    SetLoggedInUser({commit}, usr){
        console.log(`[authModule] SetLoggedInUser executing - ${usr}`)
        commit("SET_USER", usr);
        commit("SET_APP_USER", usr);
        commit("SET_API_IDTOKEN",usr.idToken)
        commit("SET_IDTOKEN",usr.idToken)
        commit("SET_AUTH_STATUS",authStatusList.AUTHORIZED);
        commit("SET_AUTHORIZED",true);
    },

   RemoveUser({commit},getters){
        commit("SET_PRE_USER", null);
        commit("SET_AUTH_STATUS",authStatusList.NONE);
    },

    GetMsalUser(state) {
        console.log(`[authModule] GetMsalUser executing`);
        console.log(`[authModule] GetMsalUser will return =>`,state.msal_app.user);
        return state.msal_app.user;


    },
    ClearMsalApp({commit}){
        commit("SET_MSAL",null);
        commit("SET_AUTH_STATUS",authStatusList.NONE);
        commit("SET_ERR",null);
        commit("SET_ERR_FLAG",false);
    },
    SetMsalUser({commit},acct){
        commit("SET_MSAL_USER", acct);
        
        commit("SET_AUTH_STATUS",authStatusList.AUTHENTICATED);

    },
    SetAppUser({commit},usr){
        commit("SET_APP_USER", usr);
        commit("SET_API_IDTOKEN",usr.idToken)
        commit("SET_IDTOKEN",usr.idToken)
        commit("SET_AUTH_STATUS",authStatusList.AUTHORIZED);
        commit("SET_AUTHORIZED",true);
    },
    SetMsalApp({commit},value){
        commit("SET_MSAL",value);
        //return state.msal_app;
    },
    SetAuthStatus({commit},value){
        commit("SET_AUTH_STATUS",value);
    },
    RecordAuthorizationFail({commit},getters){
        commit("SET_AUTH_STATUS",authStatusList.FAILED);
        commit("SET_IDTOKEN",null);
        commit("SET_ACCESSTOKEN",null);

    }, 
    SetAuth({commit},value){
        commit("SET_AUTH",value);
    },
    SetFirstAuthFlag({commit},value){
        commit("SET_LOGIN_IN_PROG",value);
    },
    SetFirstLoginInProg({commit},value){
        commit("SET_LOGIN_IN_PROG",value);
    },
    SetLoginInProgress({commit},value){
        commit("SET_LOGIN_IN_PROG", value);
    },
    SetInteractionRequired({commit},value){
        commit("SET_INTERACTION_REQUIRED", value);
    },
    SetInstanceName({commit},value){
        commit("SET_INSTANCE_NAME", value);
    },
    SetCreateTS({commit},value){
        commit("SET_CREATE_TS",value);
    },
    SetInitialLoadStatus({commit},value){
        commit("SET_INITIAL_LOAD_STAT",value);
    },

}

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};